module.exports = __webpack_public_path__ + "static/img/2.744fac95.png";